/* eslint-disable react/no-unescaped-entities */
import { ReactSVG } from 'react-svg';
import infoIconUrl from '../../assets/svgs/infoIcon.svg';
import { useState } from 'react';
import StyledInfoIconButton from '../../styles/StyledInfoIconButton';
import StyledInfoMenu from '../../styles/StyledInfoMenu';
import StyledInfoMenuContainer from '../../styles/StyledInfoMenuContainer';

const InfoMenu = () => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const onIconClick = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  return (
    <StyledInfoMenuContainer>
      <StyledInfoIconButton onClick={onIconClick}>
        <ReactSVG
          src={infoIconUrl}
          wrapper='span'
          afterInjection={(svg) => {
            svg.classList.add('svg-info-button');
            document.querySelector('.svg-info-button path')?.setAttribute('style', 'fill: #fff');
          }}
        />
      </StyledInfoIconButton>
      
      { isMenuOpened && 
        <StyledInfoMenu>
          <h3>Privacy Policy for Chat Assistant Plugin</h3>
          <p><strong>Effective Date:</strong> 01/01/2024</p>
          <p>Elora ("<em>we</em>", "<em>us</em>", or "<em>our</em>") operates this Chat Assistant plugin ("<em>Service</em>"), which is based on generative AI and is designed to provide users with information and answers regarding various companies. This Privacy Policy informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. We value your privacy and are committed to protecting your personal information.</p>

          <h4>1. Data Controller</h4>
          <p>The data controller responsible for your personal information for the purpose of the General Data Protection Regulation (GDPR) is:</p>
          
          <p>
            Elora<br/>
            42, boulevard Prince Félix<br/>
            L-1513 Luxembourg<br/>
            <a target='_blank' rel='noreferrer' href='mailto:mattieu.detaille@elora.lu'>mattieu.detaille@elora.lu</a>
          </p>

          <h4>2. Types of Data Collected</h4>
          <p>We collect and process the following personal data, if provided to the chat assistant:</p>
          <ul>
              <li>Full Names</li>
              <li>Companies</li>
              <li>Email Addresses or Phone Numbers</li>
          </ul>

          <h4>3. Purpose of Processing</h4>
          <p>Your data is collected for the purposes of:</p>
          <ul>
              <li>Enhancing the functionality and user experience of our product</li>
              <li>Conducting analytics to improve our services</li>
              <li>Contacting users with interest in the products or services of companies mentioned during the use of our Service</li>
          </ul>

          <h4>4. Legal Basis for Processing</h4>
          <p>The legal basis for processing your personal data is your explicit consent and, in certain cases, our legitimate interests in improving our Service and communications.</p>

          <h4>5. Recipients of Data</h4>
          <p>Your personal data may be shared with third-party service providers who assist us in operating our Service, conducting our business, or serving our users, so long as those parties agree to not use those data for their own purposes and keep this information confidential. We don't share your information with third parties unnecessarily.</p>

          <h4>6. Data Transfer</h4>
          <p>Your information, including Personal Data, will be stored in EU and won’t be transferred outside of EU.</p>

          <h4>7. Data Retention</h4>
          <p>We will retain your personal data for 1 year or as necessary to fulfill the purposes outlined in this Privacy Policy.</p>

          <h4>8. Your Rights</h4>
          <p>Under GDPR, you have various rights, including:</p>
          <ul>
              <li>The right to access, update or delete the information we have on you</li>
              <li>The right of rectification</li>
              <li>The right to object</li>
              <li>The right of restriction</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent</li>
          </ul>

          <h4>9. Security of Data</h4>
          <p>We are committed to protecting your data and have implemented appropriate technical and organizational measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure.</p>

          <h4>11. Consent</h4>
          <p>By using this Plugin, you consent to this policy. Users under 13 need parental consent.</p>

          <h4>10. Changes to This Privacy Policy</h4>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top of this Privacy Policy.</p>

          <h4>11. Contact Us</h4>
          <p>If you have any questions about this Privacy Policy, please contact us by email at <a target='_blank' rel='noreferrer' href='mailto:mattieu.detaille@elora.lu'>mattieu.detaille@elora.lu</a></p>

        </StyledInfoMenu> 
      }
    </StyledInfoMenuContainer>
  );
};

export default InfoMenu;